<template>
  <v-container v-if="loadingPage" class="fill-height pa-0 align-start" fluid>
    <v-progress-linear indeterminate></v-progress-linear>
  </v-container>
  <v-container v-else :fluid="$vuetify.breakpoint.lgAndDown" class="px-8 py-2 white">
    <v-row>
      <v-col class="d-flex pb-0 flex-wrap">
        <p class="display-2 font-weight-bold mr-8">Dashboard</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <BaseMyCard
          v-on="$listeners"
          v-bind="$attrs"
          class="mb-2 py-5 px-5"
          :scale="1.02"
          :ripple="false"
          style="cursor: auto !important"
        >
          <v-container>
            <v-row>
              <v-col class="title font-weight-bold grey--text py-0">
                <v-btn
                  style="cursor: auto !important"
                  small
                  fab
                  depressed
                  class="brown--text mr-2"
                  color="brown lighten-5"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>Visitas de anuncios por día
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <apexchart type="area" height="250" :options="chartOptions" :series="series"></apexchart>
              </v-col>
            </v-row>
          </v-container>
        </BaseMyCard>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="4">
        <CardDashboard :item="notices_total" />
      </v-col>
      <v-col cols="12" md="4">
        <CardDashboard :item="postulants_total" />
      </v-col>
      <v-col cols="12" md="4">
        <CardDashboard :item="empresas_total" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <BaseMyCard
          v-on="$listeners"
          v-bind="$attrs"
          class="mb-2 py-5 px-5"
          :scale="1.02"
          :ripple="false"
          style="cursor: auto !important"
        >
          <v-container>
            <v-row>
              <v-col class="title font-weight-bold grey--text py-0">
                <v-btn
                  style="cursor: auto !important"
                  small
                  fab
                  depressed
                  class="error--text mr-2"
                  color="error lighten-5"
                >
                  <v-icon>mdi-domain</v-icon>
                </v-btn>Número de postulantes por empresa
              </v-col>
            </v-row>
            <v-row class="pt-4">
              <v-col cols="12" md="6">
                <apexchart type="donut" height="250" :options="chartOptionsCompanies" :series="seriesCompanies"></apexchart>
              </v-col>
              <v-col cols="12" md="6">
                <v-card outlined>  
                  <v-data-table
                  height="200"
                  fixed-header
                    dense
                    :headers="[
                      {
                        text: 'Nombre empresa',
                        align: 'start',
                        value: 'nombre_empresa',
                        class: 'grey lighten-4',
                      },
                      {
                        text: '# postulantes',
                        align: 'end',
                        value: 'postulantes',
                        class: 'grey lighten-4',
                      },
                    ]"
                    :items="empresas"
                    :search="searchEmpresa"
                  >
                    <template v-slot:top>
                      <div class="px-4 pt-4 pb-2">
                        <v-text-field
                          v-model="searchEmpresa"
                          label="Buscar empresa"
                          dense
                          hide-details
                        ></v-text-field>
                      </div>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </BaseMyCard>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <BaseMyCard
          v-on="$listeners"
          v-bind="$attrs"
          class="mb-2 py-5 px-5"
          :scale="1.02"
          :ripple="false"
          style="cursor: auto !important"
        >
          <v-container>
            <v-row>
              <v-col class="title font-weight-bold grey--text">
                <v-btn
                  style="cursor: auto !important"
                  small
                  fab
                  depressed
                  class="grey--text mr-2"
                  color="grey lighten-5"
                >
                  <v-icon>mdi-lan</v-icon>
                </v-btn>Áreas en las que han contratado
              </v-col>
            </v-row>
            <div v-for="(empresa, index) of areas_contrataron">
              <v-row>
                <v-col class="title font-weight-bold d-flex justify-space-between align-center">
                  <div>{{ empresa.nombre }}</div>
                  <div>
                    <v-chip class="info--text" color="info lighten-5">
                      <v-icon class="mr-2">mdi-account-group</v-icon>
                      {{ empresa.total }}
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
          </v-container>
        </BaseMyCard>
      </v-col>
      <v-col cols="12" md="6">
        <BaseMyCard
          v-on="$listeners"
          v-bind="$attrs"
          class="mb-2 py-5 px-5"
          :scale="1.02"
          :ripple="false"
          style="cursor: auto !important"
        >
          <v-container>
            <v-row>
              <v-col class="title font-weight-bold grey--text">
                <v-btn
                  style="cursor: auto !important"
                  small
                  fab
                  depressed
                  class="error--text mr-2"
                  color="error lighten-5"
                >
                  <v-icon>mdi-domain</v-icon>
                </v-btn>Empresas que han contratado
              </v-col>
            </v-row>
            <div v-for="(empresa, index) of empresas_contrataron">
              <v-row>
                <v-col class="title font-weight-bold d-flex justify-space-between align-center">
                  <div>{{ empresa.nombre }}</div>
                  <div>
                    <v-chip class="info--text" color="info lighten-5">
                      <v-icon class="mr-2">mdi-account-group</v-icon>
                      {{ empresa.total }}
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </div>
          </v-container>
        </BaseMyCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import store from "@/store";
import { mapState } from "vuex";

import CardDashboard from "@/components/CardDashboard";

export default {
  components: {
    CardDashboard
  },
  data() {
    return {
      loadingPage: false,
      searchEmpresa: '',
      empresas: [],
      notices_total: {
        icon: "mdi-card-bulleted-outline",
        color: "teal",
        title: "Total avisos publicados",
        total: 0
      },
      empresas_total: {
        icon: "mdi-domain",
        color: "error",
        title: "Total empresas",
        total: 0
      },
      postulants_total: {
        icon: "mdi-account-group",
        color: "info",
        title: "Total postulantes",
        total: 0
      },
      empresas_contrataron: [],
      areas_contrataron: [],
      visitas_by_day: [],
      series: [
        {
          name: "# visitas",
          data: []
        }
      ],
      chartOptions: {
        chart: {
          type: "area",
          stacked: false,
          height: 350,
          zoom: {
            type: "x",
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: "zoom"
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0
        },
        title: {
          text: "",
          align: "left"
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 90, 100]
          }
        },
        yaxis: {
          labels: {
            formatter: function(val) {
              return val.toFixed(0);
            }
          },
          title: {
            text: "Numero de visitas"
          }
        },
        xaxis: {
          type: "datetime"
        },
        tooltip: {
          shared: false,
          y: {
            formatter: function(val) {
              return val.toFixed(0);
            }
          }
        }
      },
      seriesCompanies: [],
      chartOptionsCompanies: {
        chart: {
          width: 380,
          type: 'donut',
        },
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loadingPage = true;
      store
        .dispatch("administration/dashboard/retrieveDashboard")
        .then(data => {
          this.notices_total.total = data.notices_total;
          this.empresas_total.total = data.empresas_total;
          this.postulants_total.total = data.postulants_total;

          const companies = data.empresas.map(company => ({
            nombre_empresa: company.nombre_empresa,
            estado: company.estado,
            postulantes: company.avisos.reduce((acc, el) => acc + el.postulantes.length, 0)
          }));
          this.empresas = companies;

          const companiesByCompany = data.empresas_contrataron.reduce(
            (acc, el) => {
              if (!acc[el.aviso.empresa.nombre_empresa])
                acc[el.aviso.empresa.nombre_empresa] = [];
              acc[el.aviso.empresa.nombre_empresa].push(el);
              return acc;
            },
            {}
          );

          const areaByCompany = data.empresas_contrataron.reduce((acc, el) => {
            if (!acc[el.aviso.area]) acc[el.aviso.area] = [];
            acc[el.aviso.area].push(el);
            return acc;
          }, {});

          const visitasByCreated = data.visitas.reduce((acc, el) => {
            const dateFormat = this.$moment(el.createdAt).format("YYYY/MM/DD");
            if (!acc[dateFormat]) acc[dateFormat] = [];
            acc[dateFormat].push(el);
            return acc;
          }, {});
          const empresas_contrataron = Object.keys(
            companiesByCompany
          ).map(company => ({
            nombre: company,
            total: companiesByCompany[company].length
          }));
          const areas_contrataron = Object.keys(areaByCompany).map(area => ({
            nombre: area,
            total: areaByCompany[area].length
          }));
          const visitas_by_day = Object.keys(visitasByCreated).map(date => ({
            x: new Date(date).getTime(),
            y: visitasByCreated[date].length
          }));
          this.empresas_contrataron = empresas_contrataron;
          this.areas_contrataron = areas_contrataron;
          this.series[0].data = visitas_by_day;
          this.chartOptionsCompanies.labels = this.empresas.map(company => company.nombre_empresa);
          this.seriesCompanies = this.empresas.map(company => company.postulantes);
        })
        .finally(() => {
          this.loadingPage = false;
        });
    }
  }
};
</script>
